import Vue from 'vue';
import icon from './componentes/global/don.icon.vue';
import checkbox from './componentes/global/don.checkbox.vue';
import select from './componentes/global/don.select.vue';
import donautocomplete from './componentes/global/autocomplete/don.autocomplete.vue';
/*
 * Omite elementos de un objeto
 * obj -> objeto del que queremos quitar elementos
 * elements -> elementos a quitar ['a', 'c']
 */
Vue.prototype.$omit = function (obj, elements) {
    return Object.keys(obj).reduce((result, key) => {
        if (!elements.some(x => x === key)) {
            if (obj[key] instanceof Array) {
                const r = [];
                let self = this;
                obj[key].forEach(function (item, indice, array) {
                    r.push(self.$omit(item, elements));
                });
                result[key] = r;
            } else if (obj[key] instanceof Date) {
                result[key] = obj[key];
            } else if (obj[key] instanceof Object) {
                result[key] = this.$omit(obj[key], elements);
            }
            else {
                result[key] = obj[key];
            }
        }
        return result;
    }, {});
};

/*
* Función de agrupación de un array
* opt.group(function (item) {
*            return item.grupo;
*          })
*/
Array.prototype.group = function (key) {
    var map = {};
    this.forEach(function (e) {
        var k = key(e);
        map[k] = map[k] || [];
        map[k].push(e);
    });
    return Object.keys(map).map(function (k) {
        return { key: k, data: map[k] };
    });
}
Array.prototype.clear = function () {
    if (this) {
        this.splice(0, this.length)
    }
}
Array.prototype.removeByKey = function (key) {
    for (var i = this.length; i--;) {
        if (this[i].key.startsWith(key)) {
            this.splice(i, 1);
        }
    }
}

Vue.prototype.$normalize = function (str) {
    return str ?
        str.normalize('NFD').replace(/[\u0300-\u036f]/g, "") :
        str;
};

Vue.prototype.$format = function (amount, symbol) {
    if (amount == undefined) {
        console.error('El formato del importe es incorrecto', amount)
        return ''
    }
    if (symbol) {
        if (symbol === '€') {
            return `${parseFloat(amount).toFixed(2)}${symbol}`
        } else {
            return `${symbol}${parseFloat(amount).toFixed(2)}`
        }
    } else {
        return parseFloat(amount).toFixed(2).toString()
    }
}

String.prototype.stringFormat = function (...arr) {
    return this.replace(
        /\{([0-9]+)\}/g,
        function (_, index) {
            return arr[index];
        });
}
Vue.prototype.$bus = new Vue();

/********************************/
/*      OUR OWN JS METHODS      */
/********************************/

/*
 * Uso de $ para seleccionar elementos en JS como en jQuery
 * Use '$' for select either classes $('.className') or id $('#idName') or tags $('div')")
 */
Vue.prototype.$ = function (element) {
    return document.querySelectorAll(element)
}


/*
 * Find first child by class name
 */
Vue.prototype.$findchildbyclassname = function (element, className) {
    var foundElement = null, found;
    function recurse(element, className, found) {
        for (var i = 0; i < element.childNodes.length && !found; i++) {
            var el = element.childNodes[i];
            var classes = el.className != undefined ? el.className.split(" ") : [];
            for (var j = 0, jl = classes.length; j < jl; j++) {
                if (classes[j] == className) {
                    found = true;
                    foundElement = element.childNodes[i];
                    break;
                }
            }
            if (found)
                break;
            recurse(element.childNodes[i], className, found);
        }
    }
    recurse(element, className, false);
    return foundElement;
}


/*
 * Find first sibling by class name
 */
Vue.prototype.$sibling = function (element, className) {
    if (element && element.parentNode) {
        const siblings = element.parentNode.childNodes
        var value = null
        Array.from(siblings).forEach(function (element) {
            if (element.className == className) value = element
        })
        return value
    }
}


/* 
 * Copy elements (be carefull: incompatibilities between cloneNode(bool) and VUE components) 
 * [https://stackoverflow.com/questions/39989888/items-added-to-list-are-non-reactive-in-version-2-of-vue-js] 
 */
Vue.prototype.$prepend = function (element, to) {
    if (element && to) to.insertBefore(element.cloneNode(true), to.firstChild)
}
Vue.prototype.$append = function (element, to) {
    if (element && to) to.appendChild(element.cloneNode(true))
}


/* 
 * Move elements 
 */
Vue.prototype.$moveinsidetop = function (element, to) {
    if (element && to) to.insertBefore(element, to.firstChild)

}
Vue.prototype.$moveinsidebottom = function (element, to) {
    if (element && to) to.appendChild(element)
}

/*
* Remove element
*/
Vue.prototype.$remove = function (element) {
    if (element && element.parentNode) element.parentNode.removeChild(element)
}


/* 
* Replace element 
*/
Vue.prototype.$replace = function (element, to) {
    if (element && to) to.parentNode.replaceChild(element, to)
}


/*
* Wrap
*/
Vue.prototype.$wrap = function (element, classes) {
    if (element) {
        const donDiv = document.createElement('div')
        if (classes) donDiv.className = classes
        while (element.firstChild) donDiv.appendChild(element.firstChild)
        element.appendChild(donDiv)
    }
}


/*
* Unwrap
*/
Vue.prototype.$unwrap = function (element) {
    if (element) {
        const donParent = element.parentNode
        while (element.firstChild) donParent.insertBefore(element.firstChild, element)
        this.$remove(element)
    }
}

window.Vue = Vue;
//Componentes globales
window.Components = {
    donIcon: icon,
    donCheckbox: checkbox,
    donSelect: select,
    donautocomplete: donautocomplete
};



// WEBPACK FOOTER //
// ./src/global.main.js